(function(){
    'use strict'

    angular.module('app.usuarios-organizador')
    .factory('UsuariosOrganizadorService', UsuariosOrganizadorService);

    UsuariosOrganizadorService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function UsuariosOrganizadorService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update: update,
            remove: remove,
            changePassword: changePassword,
            saveEvento: saveEvento,
            removeEvento: removeEvento
        };

        return api;

        function getStringParams(params){
            let stringParams = '';
            if(params != undefined && params != null)
            {
                params.forEach(element => {
                    stringParams += `/${element}`
                });
            }
            return stringParams;
        };

        function getAll(params){

            var url = apiSettings.apiBaseUrl + 'api/usuarios-organizador' + getStringParams(params);
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(usuarioId){

            var url = apiSettings.apiBaseUrl + 'api/usuarios-organizador/' + usuarioId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios-organizador',  
                method: 'POST',  
                data: usuario
            });  
            return response;
        };

        function update(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios-organizador',  
                method: 'PUT',  
                data: usuario
            });  
            return response;
        };

        function remove(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios-organizador',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: usuario
            });  
            return response;
        };

        function changePassword(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios-organizador/change-password',  
                method: 'PUT',  
                data: usuario
            });  
            return response;
        };

        function saveEvento(evento){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/permisos-eventos',  
                method: 'POST',  
                data: evento
            });  
            return response;
        };

        function removeEvento(evento){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/permisos-eventos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: evento
            });  
            return response;
        };

    };

})();